"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIconGroup = exports.AvatarGroup = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/avatar.css");
/**
 * Group Avatars together.
 *
 * Avatars stacking is based on `maxAvatars` count. If you provide 8 Avatars and keep default 5 `maxAvatars` count,
 * this component will show 5 Avatars and Count Avatar with "3" in it.
 *
 * You can add custom Count Avatar behavior by using `countAvatarProps`.
 *
 * @example
 * <AvatarGroup iconSize='medium'>
 *  <Avatar
 *    abbreviation="TR"
 *    backgroundColor={getUserColor("Terry Rivers")}
 *    title="Terry Rivers"
 *  />
 *  <Avatar
 *    abbreviation="RM"
 *    backgroundColor={getUserColor("Robin Mercer")}
 *    title="Robin Mercer"
 *  />
 *  <Avatar
 *    abbreviation="JM"
 *    backgroundColor={getUserColor("Jean Mullins")}
 *    title="Jean Mullins"
 *  />
 * </AvatarGroup>
 */
const AvatarGroup = (props) => {
    const maxLength = 99;
    const { children, animated = false, stacked = true, maxIcons = 5, iconSize = 'small', countIconProps, className, ...rest } = props;
    const childrenArray = React.Children.toArray(children);
    const childrenLength = childrenArray.length;
    (0, index_js_1.useTheme)();
    const getAvatarList = (count) => {
        return childrenArray.slice(0, count).map((child) => React.cloneElement(child, {
            status: undefined,
            size: iconSize,
        }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: (0, classnames_1.default)('iui-avatar-list', {
                'iui-animated': animated,
                'iui-stacked': stacked,
            }, className), ...rest },
            childrenArray.length <= maxIcons + 1 && getAvatarList(maxIcons + 1),
            childrenArray.length > maxIcons + 1 && (React.createElement(React.Fragment, null,
                getAvatarList(maxIcons),
                React.createElement("div", { ...countIconProps, className: (0, classnames_1.default)('iui-avatar', { [`iui-${iconSize}`]: iconSize !== 'medium' }, 'iui-avatar-count', countIconProps === null || countIconProps === void 0 ? void 0 : countIconProps.className) },
                    React.createElement("abbr", { className: 'iui-initials' }, childrenLength <= maxLength
                        ? `${childrenLength - maxIcons}`
                        : `${maxLength}+`),
                    React.createElement("span", { className: 'iui-stroke' })))))));
};
exports.AvatarGroup = AvatarGroup;
/**
 * @deprecated Since v2, this has been renamed to `AvatarGroup`
 */
exports.UserIconGroup = exports.AvatarGroup;
exports.default = exports.AvatarGroup;
